<template>
    <div class="page">
        <div class="page-bd max">
            <Row type="flex" :gutter="3">
                <Col class="mg-10" span="6">
                    <Card :dis-hover="true">
                        <p slot="title">
                            <span class="f-red"><Icon type="md-flash" />{{$t('clean_cache')}}</span>
                        </p>
                        <div class="tright">
                            <Button type="primary" @click="clearCache()">{{$t('clean_label')}}</Button>
                        </div>
                    </Card>
                </Col>
                <Col class="mg-10" span="6">
                    <Card :dis-hover="true">
                        <p slot="title">
                            <span class="f-red"><Icon type="md-flash" />{{$t('clean_com_setup')}}</span>
                        </p>
                        <div class="tright">
                            <Button type="primary" @click="clearComSetup()">{{$t('clean_label')}}</Button>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../components/myNav"
    import myNodata from '../../components/myNodata'
    export default {
        name:'system-redis',
        components:{
            myNav,
            myNodata,
        },
        data:function(){
            return{
                title: this.$t("cache_manage"),
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                listData: [
                    {
                        clear_cname: this.$t('clean_cache'),
                        clear_id: "1",
                        sort_id: "a11"
                    }
                ],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
        },
        methods:{
            clearCache() {
                this.$base.showLoading();
                this.$request.sendPost('redis/clear-com',{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg)
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            clearComSetup() {
                this.$base.showLoading();
                this.$request.sendPost('redis/clear-com-setup',{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg)
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/system/cache.vue